import { createMuiTheme } from '@material-ui/core/styles';
import colors from 'theme/colors';

const { fontBody } = colors;

// Note: Pulled from Apple
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Avenir Next',
      'Nunito',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontSize: '3rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '1rem',
      letterSpacing: '0.17px',
      fontWeight: 'bold',
      lineHeight: '24px',
    },
    h3: {
      fontSize: '1rem',
      letterSpacing: '0.6px',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1rem',
      letterSpacing: '0.47px',
      fontWeight: 'bold',
    },
    h5: {
      fontSize: '1rem',
      letterSpacing: '0.11px',
      fontWeight: 'bold',
    },
    body1: {
      color: fontBody,
      fontSize: '1rem',
      letterSpacing: '0.11px',
      lineHeight: '24px',
      fontWeight: 400,
    },
    body2: {
      fontSize: '0.875rem',
    },
    button: {
      fontSize: '1rem',
      fontWeight: 600,
      letterSpacing: '0.95px',
      textTransform: 'uppercase',
    },
  },
  overrides: {
    MuiInputBase: {
      input: {
        height: 20,
        fontSize: 14,
        color: fontBody,
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: 14,
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 14,
        padding: 8,
      },
    },
  },
});

export default theme;
